module.exports = __webpack_public_path__ + "img/white_check_mark.40de3a5a.svg";